import React from 'react';

import { BaseAutocompleteOption } from '@savgroup-front-common/types';

import {
  safeFormattedIntlString,
  SafeFormattedMessage,
} from '../../../../formatters';
import { StringHelper } from '../../../../helpers/stringHelpers';
import { $HighlightedMatch } from '../Autocomplete.styles';

function DefaultOptionFormatter<Option extends BaseAutocompleteOption>({
  label,
  search,
}: Option & { search?: string }) {
  if (!search) {
    return <div>{SafeFormattedMessage(label)}</div>;
  }

  const labelString = safeFormattedIntlString(label);
  const segments = StringHelper.highlightSearchMatches({
    target: labelString,
    searchString: search,
  });

  return (
    <div>
      {segments.map((segment, index) => {
        if (segment.isMatch) {
          return (
            <$HighlightedMatch key={index}>{segment.text}</$HighlightedMatch>
          );
        }

        return <React.Fragment key={index}>{segment.text}</React.Fragment>;
      })}
    </div>
  );
}

export default DefaultOptionFormatter;
